import { ConnectedApps } from "../ConnectedApps";
import Section from "./Section";

import type { ConfigSection } from "../ConfigSectionHelp";
import type { Agent } from "@/shared/types";

export default function AppsSection({ agent, onUpdateAgent, onHelp }: {
  agent: Agent;
  onUpdateAgent: (updater: (a: Agent) => Agent) => void;
  onHelp: (section: ConfigSection) => void;
}) {
  const enabled = !!agent.capabilities?.appsEnabled;
  const toggle = () => onUpdateAgent((a) => ({ ...a, capabilities: { ...a.capabilities, appsEnabled: !enabled } }));
  return (
    <Section section="apps" onHelp={onHelp} enabled={enabled} onToggle={toggle}>
      <ConnectedApps agentId={agent.id} />
    </Section>
  );
}
